import { formatCurrency } from '../utils/utils'
import { ProductPriceLocale } from './productData'

export default class Price {
  constructor(public value: number, private locale: ProductPriceLocale) {}

  get formatted() {
    return formatCurrency(this.value, this.locale)
  }
}
